module.exports = __webpack_public_path__ + "img/ltkvideo-3x.fa86e54.jpg";